export * from './model.model';
export * from './model-popup.service';
export * from './model.service';
export * from './model-dialog.component';
export * from './model-delete-dialog.component';
export * from './model-detail.component';
export * from './model.component';
export * from './model.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model/index.ts